import { useFirestoreGeneralOrderBy } from '../../firebase/useFirestore'
import { useTranslation } from '../../StateManagment/TranslationContext'

// De antwoordopties van een meerkeuzevraag op het printvel.
//
// Papier volgt het scherm: bij één mogelijk antwoord een rondje, bij meerdere
// een vinkvakje. Stond hier vroeger overal een vinkvakje, waarmee het vel de
// invuller uitnodigde tot een antwoord dat de digitale vragenlijst weigert.
//
// Alleen de printpagina rendert dit component; het invulscherm heeft zijn eigen
// weergave in `components/open/FieldType.jsx` (die schrijft antwoorden weg).

/**
 * @param {object} props
 * @param {string} props.fieldID - `MultipleQuestionOptions.Field`
 * @param {string} [props.fieldType] - 'multiple-one' of 'multiple-multiple';
 *   onbekend valt terug op het vinkvakje, dat niets belooft wat niet kan
 */
const MultipleOptions = ({ fieldID, fieldType }) => {

    const multipleOptions = useFirestoreGeneralOrderBy('MultipleQuestionOptions', 'Field', fieldID ? fieldID : '', 'Position', 'asc')
    // Antwoordteksten worden op zichzelf gesleuteld, niet op een ID — zelfde
    // afspraak als in het invulscherm.
    const { translations } = useTranslation()

    const inputType = fieldType === 'multiple-one' ? 'radio' : 'checkbox'

  return (
    <div id='options-container'>
        {multipleOptions && multipleOptions.map(item => (
        <div key={item.ID} className='options-item-container'>
            <input
                className='question-checkbox-input'
                name={fieldID}
                type={inputType}
                value={item.Option}
                readOnly
            />
            <label htmlFor={item.Option}>
                {item.Option === 'other'
                    ? (translations?.['Overig...'] || 'Overig...')
                    : (translations?.[item.Option] || item.Option)}
            </label>
        </div>
    ))}</div>
  )
}

export default MultipleOptions
